var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M1.525 7.85a.936.936 0 0 1 0-1.326L5.9 2.15a.937.937 0 1 1 1.325 1.325L4.451 6.25h8.986a1 1 0 0 1 .213.024 5.626 5.626 0 0 1-.525 11.226h-2.13a.938.938 0 0 1 0-1.875h2.13a3.751 3.751 0 0 0 0-7.5H4.451L7.225 10.9A.937.937 0 0 1 5.9 12.224z"
})));
export { SvgUndo as ReactComponent };
export default __webpack_public_path__ + "static/media/undo.09907e81.svg";